// extracted by mini-css-extract-plugin
export default {"body":"_W8ucb","cta":"_myg19"};